export default __webpack_public_path__ + "static/media/chiv.c6e67e4a.jpg";